import { DeploymentService } from 'phoenix/services';
/**
* A service used to construct ShareBase administration URI paths
**/
export class DeploymentNameService {
	private deploymentSystemNamesCache: any[] = [];
	private errorMessage:string;

	static $inject = [
		'$q', 
		'pxDeploymentService', 
		'pxAuthService', 
		'gettextCatalog'
	];
	
	constructor(
		private $q: ng.IQService,
		private pxDeploymentService:DeploymentService,
		private pxAuthService,
		private gettextCatalog:ng.gettext.gettextCatalog
	) {
		this.errorMessage = this.gettextCatalog.getString('Error getting system name. Invalid deployment ID.');
	}

	/**
	* Resolves a deployment's "SystemName" by deploymentID 
	* @param {number} deploymentId - Deployment's ID
	* @returns {ng.IPromise<string>} SystemName of deployment or null if it cannot be returned
	*/	
	public resolveSystemName(deploymentId: number): ng.IPromise<string> {
		return this.$q<string>((resolve, reject) => {
			if (this.deploymentSystemNamesCache[deploymentId]) {
				resolve(this.deploymentSystemNamesCache[deploymentId]);
			}
			else if (this.pxAuthService.deploymentId == deploymentId) {
				this.updateCache(deploymentId, this.pxAuthService.systemName);
				resolve(this.pxAuthService.systemName);
			}
			else {
				this.pxDeploymentService.getDetails(deploymentId)
					.then((deployment) => {
						this.updateCache(deploymentId, deployment.SystemName);
						resolve(deployment.SystemName);
					})
					.catch(() => {
						reject(new Error(this.errorMessage));
					});
			}
		});
	}

	private updateCache(deploymentId, deploymentSystemName) {
		this.deploymentSystemNamesCache[deploymentId] = deploymentSystemName;
	}
}



// WEBPACK FOOTER //
// ./src/sharebase/services/deploymentNameService.ts